import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c45aa9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, null, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.useConfig.text), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.useimg,
        class: "store-img"
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}